import { Controller } from "@hotwired/stimulus"

// Show the servings field for one planned meal.
//
// Servings are almost always 1, so the field is hidden by default. It used
// to appear on hover, which meant movement on every meal the pointer crossed
// — now it takes a deliberate click on the edit control.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    // Close when the pointer leaves the DAY, not the meal.
    //
    // A day column only shows its meals while you are pointing at it, so a
    // panel opened and left open sat inside a collapsed column and was still
    // there when you came back — an edit you had visibly walked away from.
    // Leaving the meal itself would be too eager: reaching for the field is
    // a move off the meal name and onto the input.
    //
    // The wide layout expands on :hover with no JS behind it, so this is the
    // only event that says you have gone.
    this.day = this.element.closest(".day-meals")

    if (!this.day) return

    this.closeOnLeave = () => this.close()
    this.day.addEventListener("mouseleave", this.closeOnLeave)
  }

  disconnect() {
    if (this.closeOnLeave) this.day?.removeEventListener("mouseleave", this.closeOnLeave)
  }

  toggle() {
    if (!this.hasPanelTarget) return

    this.panelTarget.classList.toggle("is-open")
    if (this.panelTarget.classList.contains("is-open")) {
      this.panelTarget.querySelector("input")?.focus()
    }
  }

  close() {
    if (!this.hasPanelTarget) return
    // Not while it holds focus: a pointer that strays off the column mid-type
    // should not take the field out from under the keyboard.
    if (this.panelTarget.contains(document.activeElement)) return

    this.panelTarget.classList.remove("is-open")
  }
}
